import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import SubscribeModal from '../components/SubscribeModal';

//import SubFooter from '../components/SubFooter'
import '../scss/style.scss'

const Layout = props => {

  const [modalVisible, setModalVisible] = useState(false);
  const [stickyTableState, setStickyTableState] = useState('');
  const [cookies, setCookie, removeCookie] = useCookies(['popup-closed']);
  const [submitted, setSubmitted] = useState(false);

  const showModal = () => {
      setModalVisible(true);
  };

  const hideModal = () => {
      setModalVisible(false);
      if (submitted) {

      }
  };

  useEffect(() => {
    if(props.context === 'blog' && !cookies['popup-closed']){
      const popUpTimer = setTimeout(() => {
         showModal()
      }, 15000);

      return () => clearTimeout(popUpTimer)   
    }
  }, []);

  const setPopupCookie = () => setCookie('popup-closed', true, { path: '/', expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)) });


  return (
    <React.Fragment>
      <SEO />
      <div className={`page${props.bodyClass ? ` ${props.bodyClass}` : ''}`}>
        <div id="wrapper" className="wrapper">
          <Header showSearchBar={props.showSearchBar}/>
            <Modal className={'blog-popup'} show={modalVisible} handleClose={hideModal}>
              <SubscribeModal onSuccess={() => setPopupCookie()}/>
            </Modal>
          {props.children}
		  <Footer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Layout
